import React from "react";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  cellExpandClassname: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
    // "& span": {
    //   display: 'table-cell',
    //   verticalAlign: 'middle',
    //   cursor: 'pointer'
    // }
  }
}));

export function CellExpanderFormatter({ tabIndex, expanded, onCellExpand }) {
  const classes = useStyles();
  function handleKeyDown(e) {
    if (e.key === " " || e.key === "Enter") {
      e.preventDefault()
      onCellExpand()
    }
  }

  return (
    <div className={classes.cellExpandClassname} onKeyDown={handleKeyDown}>
      <span onClick={onCellExpand} >
        <span tabIndex={tabIndex}>{expanded ? "\u25BC" : "\u25B6"}</span>
      </span>
    </div>
  )
}